import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCpf from '../../../components/form/InputCpf';
import InputNomeCompleto from '../../../components/form/InputNomeCompleto';
import useAlerta from '../../../components/hooks/useAlerta';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
//import { RECADASTRAMENTO_PF } from '../../../services/cadastro';
import { RECADASTRAMENTO_PF } from '../../../services/meuCorreios';
import { createFormSchemas } from './FormSchema';

const Recadastramento = () => {
  const { t } = useTranslation();
  const { formSchemaRecadastramento } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaRecadastramento) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };

    fetchIPAddress();
  }, []);
  const { abreAlerta } = useAlerta();
  const navigate = useNavigate();
  const { request } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const [desabilitarCampoMae, setDesabilitarCampoMae] = useState(true);
  const [isCheckedNomeMaeDesconhecido, setIsCheckedNomeMaeDesconhecido] =
    useState(false);
  const handleNomeMaeDesconhecido = () => {
    setIsCheckedNomeMaeDesconhecido(!isCheckedNomeMaeDesconhecido);
  };

  useEffect(() => {
    if (!isCheckedNomeMaeDesconhecido) {
      setDesabilitarCampoMae(false);
    } else {
      document.getElementById('nomeDaMae').value = '';
      setDesabilitarCampoMae(true);
    }
  }, [isCheckedNomeMaeDesconhecido]);

  const handleSubmit = async (data) => {
    let nomeDaMae = data.nomeDaMae;
    if (isCheckedNomeMaeDesconhecido) {
      nomeDaMae = 'MAE DESCONHECIDA';
    }
    const dataNasc = new Date(data.dataNascimento);
    const yyyy = dataNasc.getFullYear();
    const mm = String(dataNasc.getMonth() + 1).padStart(2, '0');
    const dd = String(dataNasc.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    const dadosEnvio = {
      dataNascimento: formattedDate,
      mae: nomeDaMae.trim(),
      nome: data.nome.trim(),
    };

    const { response } = await request(
      RECADASTRAMENTO_PF(dados.idCorreios, dadosEnvio, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog(t('cadastro.messages.success.reregistration'));
      navigate('/principal');
    }
  };

  return (
    <>
      <div className="conteudo">
        <div id="cadastro-pf" className="card bg-superficie elev5">
          <img
            alt="imagem de perfil da carol, assistente virtual dos correios"
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h2>Recadastramento</h2>

          <p className="justificado">
            Caro Cliente,
            <br />
            <br />
            <a
              href="https://www.correios.com.br/central-de-informacoes/boletim-aos-clientes/meu-correios-seguranca-e-confiabilidade-para-seus-dados"
              target="_blank"
              rel="noopener noreferrer"
              className="link-grande"
            >
              Conforme divulgado em nosso site,
            </a>
            &ensp;estamos realizando uma higienização nas contas Meu Correios
            para garantir maior transparência e segurança à gestão dos dados de
            cadastro, aperfeiçoando a validação do CPF e do CNPJ dos nossos
            clientes. Portanto estamos validando seus dados de nome, data de
            nascimento e nome da mãe conforme os constantes em seu cadastro de
            CPF na Receita Federal do Brasil, caso qualquer uma das informações
            estejam divergentes, para consultar seus dados de CPF, acesse o link
            da &ensp;
            <a
              href="https://cav.receita.fazenda.gov.br/autenticacao/login"
              target="_blank"
              rel="noopener noreferrer"
              className="link-grande"
            >
              Receita Federal do Brasil.
            </a>
          </p>

          <hr />
          <p className="justificado">
            Você terá apenas três tentativas. Caso não consiga realizar a
            validação, o seu cadastro será cancelado e será necessário criar um
            novo cadastro.
          </p>
          <form
            id="formReadastramento"
            onSubmit={methods.handleSubmit(handleSubmit)}
          >
            <InputCpf
              label="CPF*"
              type="text"
              id="cpf"
              name="cpf"
              disabled
              defaultValue={dados.usuarioExternoPF.cpfFormatado}
              {...formMethods}
            />

            <InputNomeCompleto
              type="text"
              id="nome"
              name="nome"
              placeholder=""
              label="Nome / Nome social*"
              {...formMethods}
            />

            <InputNomeCompleto
              type="text"
              id="nomeDaMae"
              name="nomeDaMae"
              label="Nome da mãe*"
              placeholder=""
              disabled={desabilitarCampoMae}
              {...formMethods}
            />
            <label className="input-checkbox">
              <Input
                type="checkbox"
                id="maeDesconhecida"
                name="maeDesconhecida"
                onClick={handleNomeMaeDesconhecido}
                defaultChecked={isCheckedNomeMaeDesconhecido}
                {...formMethods}
              />
              <div className="subtitulo-p">Mãe desconhecida</div>
            </label>
            <InputCadastro
              className="input-data"
              type="date"
              id="dataNascimento"
              name="dataNascimento"
              label="Nascimento*"
              {...formMethods}
            />

            <div className="btns-row">
              <button
                id="btn-prosseguir"
                type="submit"
                className="btn-pre primario"
              >
                Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default Recadastramento;
